module.exports = __webpack_public_path__ + "media/images/dashboards/parkinsons-c564ee6956d4b7ea5522d68a93bd949d.png";